import Link from 'next/link'

import AutoreCard from 'components/card/AutoreCard'
import ModalContattaEsperto from './ModalContattaEsperto'
import { useState } from 'react'

function BoxSportello({ autore, detail, faq }) {
  const [modal, setModal] = useState(false)

  function handleDomanda() {
    setModal(true)
  }

  return detail ? (
    <div className={`box-sportello`}>
      <div className="box-sportello__intro">
        <h4 className="box-sportello__title">
          {autore.nome} {autore.cognome} è l'esperto dello {autore.paginafaq?.titolo}
        </h4>
        <p className="box-sportello__disclaimer">
          Hai un abbonamento a io+? Fai la tua domanda a {autore.nome} {autore.cognome}, ti
          risponderà in privato.
        </p>
      </div>
      <div className="box-sportello__actions">
        <Link legacyBehavior href={`${autore.url}faq`}>
          <a className="button button--primary">Leggi le domande degli utenti</a>
        </Link>
        <button className="button button--secondary" onClick={handleDomanda}>
          Fai una domanda
        </button>
      </div>
      <ModalContattaEsperto modal={modal} setModal={setModal} autore={autore} />
    </div>
  ) : faq ? (
    <div className={`box-sportello box-sportello--faq`}>
      <div className="box-sportello__intro">
        <AutoreCard autore={autore} classes="autore-card--sportello" />
        <p className="box-sportello__intro__biografia">{autore.biografia}</p>
      </div>
      <div className="box-sportello__actions">
        <button className="button button--primary" onClick={handleDomanda}>
          Fai una domanda
        </button>
        <Link legacyBehavior href={autore.url}>
          <a className="button button--secondary">Leggi la biografia</a>
        </Link>
        <ModalContattaEsperto modal={modal} setModal={setModal} autore={autore} />
      </div>
    </div>
  ) : null
}

export default BoxSportello
